import { createModalContext } from "shared/components/vero-modal";

export const {
  Context: ApproveDealModalContext,
  Provider: ApproveDealModalProvider,
  useModalContext: useApproveDealModal,
} = createModalContext();
